// extracted by mini-css-extract-plugin
var _1 = "PdfViewer-modulePdfViewer__x8M2s";
var _2 = "PdfViewer-moduledocumentArea__Lk99f";
var _3 = "PdfViewer-moduledocumentAreaBody__BpgE8";
var _4 = "PdfViewer-moduledocumentAreaContent__k_8jT";
var _5 = "PdfViewer-moduledocumentLoadError___Jjsl PdfViewer-moduledocumentLoader__e2uNB";
var _6 = "PdfViewer-moduledocumentLoader__e2uNB";
var _7 = "PdfViewer-modulepageFitContainer__YkgU4";
var _8 = "PdfViewer-modulepanContainer__cUVGs";
var _9 = "PdfViewer-modulepanningContainer___TXgL";
var _a = "PdfViewer-moduleselectAreaLayer__ccpkW";
var _b = "PdfViewer-modulethumbnailsPanel__mwwUH PdfViewerThumbnails-modulePdfViewerThumbnails___OnRR";
var _c = "PdfViewer-moduleviewerContainer__ExgvC";
var _d = "PdfViewer-modulewithThumbnails__edSqH";
export { _1 as "PdfViewer", _2 as "documentArea", _3 as "documentAreaBody", _4 as "documentAreaContent", _5 as "documentLoadError", _6 as "documentLoader", _7 as "pageFitContainer", _8 as "panContainer", _9 as "panningContainer", _a as "selectAreaLayer", _b as "thumbnailsPanel", _c as "viewerContainer", _d as "withThumbnails" }
